import type { LayoutItem } from 'react-grid-layout';

import type { PanelId, TradeLayoutState } from './types';

export const gridCols = 12;
export const gridRowHeight = 14;
export const gridMargin: [number, number] = [10, 10];
export const orderFormWidth = 360;
export const persistDebounceMs = 300;
export const layoutVersion = 2;
export const chartMinPx = 300;
export const orderbookMinPx = 240;
export const etcSectionMinPx = 614;

export const panelIds: PanelId[] = ['symbolInfo', 'chart', 'orderbook', 'etcSection'];

/**
 * Default layout items for react-grid-layout.
 *
 * Grid unit sizing with rowHeight=14, margin=[10,10]:
 *   pixelHeight ≈ 14×h + 10×(h−1) = 24h − 10
 *
 * symbolInfo (h=3): 62px | chart (h=25): 590px
 * orderbook (h=25): 590px | etcSection (h=25): 590px
 */
export const defaultLayouts: LayoutItem[] = [
  { i: 'symbolInfo', x: 0, y: 0, w: 12, h: 3, minW: 4, minH: 3, maxH: 3 },
  { i: 'chart', x: 0, y: 3, w: 9, h: 25, minW: 4, minH: 9 },
  { i: 'orderbook', x: 9, y: 3, w: 3, h: 25, minW: 2, minH: 9, maxH: 46 },
  { i: 'etcSection', x: 0, y: 28, w: 12, h: 25, minW: 4, minH: 17 },
];

export const defaultLayoutState: TradeLayoutState = {
  layouts: defaultLayouts,
  hiddenPanels: [],
  version: layoutVersion,
};
